import { defineComponent as o, useSlots as s, openBlock as r, createBlock as d, unref as i, withCtx as n, renderSlot as c, createElementBlock as g, createElementVNode as t, toDisplayString as u } from "vue";
import f from "./ghl-ui.es344.js";
const y = { key: 1 }, p = {
  class: "n-progress-text",
  role: "none"
}, h = { class: "n-progress-text__percentage" }, m = /* @__PURE__ */ t("span", { class: "n-progress-text__unit" }, "%", -1), b = o({
  name: "UIProgress",
  inheritAttrs: !1
}), S = o({
  ...b,
  props: {
    percentage: {
      type: Number
    },
    type: {
      type: String,
      default: "line"
    },
    processing: {
      type: Boolean
    },
    indicatorPlacement: {
      type: String,
      default: "inside"
    },
    status: {
      type: String
    },
    showIndicator: {
      type: Boolean,
      default: void 0
    },
    borderRadius: {
      type: [Number, String],
      default: void 0
    },
    circleGap: {
      type: Number,
      default: 1
    },
    color: {
      type: [String, Array],
      default: void 0
    },
    fillBorderRadius: {
      type: [Number, String],
      default: void 0
    },
    gapDegree: {
      type: Number,
      default: 75
    },
    gapOffsetDegree: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: void 0
    },
    indicatorTextColor: {
      type: String,
      default: void 0
    },
    offsetDegress: {
      type: Number,
      default: 0
    },
    railColor: {
      type: [String, Array],
      default: void 0
    },
    railStyle: {
      type: [String, Object, Array],
      default: void 0
    },
    strokeWidth: {
      type: Number,
      default: 7
    },
    unit: {
      type: String,
      default: "%"
    }
  },
  setup(e) {
    const a = s();
    return (l, N) => (r(), d(i(f), {
      "indicator-placement": e.indicatorPlacement,
      percentage: e.percentage,
      processing: e.processing,
      "show-indicator": e.showIndicator,
      status: e.status,
      type: e.type,
      "gap-position": "bottom",
      "border-radius": e.borderRadius,
      "circle-gap": e.circleGap,
      color: e.color,
      "fill-border-radius": e.fillBorderRadius,
      "gap-degree": e.gapDegree,
      "gap-offset-degree": e.gapOffsetDegree,
      height: e.height,
      "indicator-text-color": e.indicatorTextColor,
      "offset-degress": e.offsetDegress,
      "rail-color": e.railColor,
      "rail-style": e.railStyle,
      "stroke-width": e.strokeWidth,
      unit: e.unit
    }, {
      default: n(() => [
        i(a).default ? c(l.$slots, "default", { key: 0 }) : (r(), g("div", y, [
          t("div", p, [
            t("span", h, u(e.percentage), 1),
            m
          ])
        ]))
      ]),
      _: 3
    }, 8, ["indicator-placement", "percentage", "processing", "show-indicator", "status", "type", "border-radius", "circle-gap", "color", "fill-border-radius", "gap-degree", "gap-offset-degree", "height", "indicator-text-color", "offset-degress", "rail-color", "rail-style", "stroke-width", "unit"]));
  }
}), x = S;
export {
  x as default
};
